import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirModificacaoDadosCadastrais } from './types';

export const INITIAL_STATE: emitirModificacaoDadosCadastrais = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirModificacaoDadosCadastrais {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_MODIFICACAO_DADOS_CADASTRAIS_REQUEST: {
				break;
			}

			case Types.EMITIR_MODIFICACAO_DADOS_CADASTRAIS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_MODIFICACAO_DADOS_CADASTRAIS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.EMITIR_MODIFICACAO_DADOS_CADASTRAIS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
